import Vue from 'vue'
import Vuex from 'vuex'
import cart from './modules/cart'
import checkout from './modules/checkout'
import billing from './modules/billing'
import shipping from './modules/shipping'
import contact from './modules/contact'
import rewards from './modules/rewards'
import payment from './modules/payment'
import shippingMethods from './modules/shipping_methods'
import * as h from "../components/checkout/helper";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        cart,
        checkout,
        payment,
        shipping,
        shippingMethods,
        contact,
        billing,
        rewards,
    },
    actions: {
        updateCheckout({commit, state}, checkout, callable) {
            commit('rewards/setAppliedPoints', checkout.points || 0);
            commit('rewards/setIsShippedForPoints', checkout.is_shipped_for_points || false);

            commit('checkout/setObj', checkout);

            if (typeof callable === 'function') {
                callable(true);
            }

            h.sendGoogleAnalytics(checkout.products);
        },
    }
})
